import * as React from "react";
import { useCallback } from "react";

import BoxContainer from "@hl/base-components/lib/BoxContainer";
import { SECONDARY_COLOR } from "@hl/base-components/lib/theme/button";
import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { GetUserAccountSettingsDocument } from "@hl/shared-features/lib/features/auth/queries/queries/accountSettings.graphql.generated";
import { logError } from "@hl/shared-features/lib/services/logger";
import { Button, Group, Stack, Text } from "@mantine/core";

import {
  PublicUserProfileDocument,
  PublicUserProfileQuery,
  useDisconnectTwitterMutation,
  useGenerateTwitterAuthUrlMutation,
} from "../queries/profile.graphql.generated";

export interface Props {
  profile?: PublicUserProfileQuery["getPublicAccountSettings"];
  loading: boolean;
}

export const LinkXInput = ({ profile, loading }: Props) => {
  const [generateTwitterAuthUrlMutation] = useGenerateTwitterAuthUrlMutation();
  const [disconnectTwitterMutation] = useDisconnectTwitterMutation();

  const username = profile?.socials?.twitter?.username;

  const handleTwitterClick = useCallback(async () => {
    try {
      if (username) {
        await disconnectTwitterMutation({
          refetchQueries: [
            GetUserAccountSettingsDocument,
            PublicUserProfileDocument,
          ],
        });
      } else {
        const { data } = await generateTwitterAuthUrlMutation();
        if (!data?.generateTwitterAuthURL) {
          throw new Error("twitter URL empty");
        }
        window.location.href = data.generateTwitterAuthURL;
        //window.open(data.generateTwitterAuthURL, "_blank");
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      await logError({ error, message: "twitter update failed" });
    }
  }, [username]);

  return (
    <Stack spacing={4}>
      <BoxContainer p="8px 16px">
        <Group position="apart">
          <Group spacing={10}>
            <Text
              size="sm"
              color={username ? TEXT_COLOR.PRIMARY : TEXT_COLOR.PLACEHOLDER}
            >
              {username ? `@${username}` : "@username"}
            </Text>
          </Group>
          <Button
            component="a"
            target="_blank"
            onClick={handleTwitterClick}
            color={SECONDARY_COLOR}
            size="xs"
            px={12}
            loading={loading}
          >
            {username ? "Unlink X" : "Link X"}
          </Button>
        </Group>
      </BoxContainer>
    </Stack>
  );
};
